// extracted by mini-css-extract-plugin
export default {"warning":"W5W4V"};